import { useLocation } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track } from 'modules/core/lib/Tracking'

interface EventProps {
  moduleName: string
  chargebeeId: string
  isPopularModule?: boolean
}

const useSubscriptionOverloadEvent = ({
  moduleName,
  chargebeeId,
  isPopularModule = false,
}: EventProps) => {
  const { company } = useCurrentSession()
  const { pathname } = useLocation()

  const eventPayload = {
    page_path: pathname,
    page_url: window.location.href,
    form_number_of_employees: company.numberEmployees,
    module_name: moduleName,
    chargebee_id: chargebeeId,
    from_popular_section: isPopularModule,
  }

  const eventEmitter = (eventName: string) => {
    track(eventName, eventPayload)
  }

  return { eventEmitter, eventPayload }
}

export default useSubscriptionOverloadEvent
